(function () {
  'use strict';

  let angular = window.angular;

  DetectionsHistoryRouter.$inject = ['$stateProvider'];

  angular.module('app').config(DetectionsHistoryRouter);

  function DetectionsHistoryRouter($stateProvider) {
    $stateProvider.state('member.customer.show.project.detectionsHistory', {
      url: '/detections-history/:assetId?date',
      component: 'detectionsHistoryV2',
      authenticated: true,
      params: {
        assetId: {
          type: 'string',
          dynamic: true,
          squash: true,
        },
      },
      ncyBreadcrumb: {
        label: 'Detections History',
      },
      resolve: {
        dependencies: [
          '$ocLazyLoad',
          '$rootScope',
          function ($ocLazyLoad, $root) {
            const theme = $root.darkMode ? 'dark' : 'light';
            return $ocLazyLoad.load([
              window.assetsPath + '/js/app/detections-history.module.min.js',
              window.assetsPath + `/js/vendors/chart-vendors-${theme}.min.js`,
            ]);
          },
        ],
      },
    });
  }
})();
